import http from "../httpService";
import {getBaseUrl} from "../../config";


export const postValidateBackOfficeReservationDiscount = (data, personId) => {
  return http.post(
    `${getBaseUrl()}/validate_back_office_reservation_discount/${personId}`,
    data
  );
};

export const postValidateBackOfficeServiceDiscount = (data, personId) => {
  return http.post(
    `${getBaseUrl()}/validate_back_office_service_discount/${personId}`,
    data
  );
};